import React from "react";

const WhatsAppButton = () => {
  return (
    <a
      href="https://wa.me/923333896737?text=Hello%2C%20I%20need%20help"
      target="_blank"
      rel="noopener noreferrer"
      style={buttonStyle}
    >
      <img
        src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg"
        alt="WhatsApp"
        style={imageStyle}
      />
    </a>
  );
};

const buttonStyle = {
  position: "fixed",
  bottom: "20px",
  right: "20px",
  backgroundColor: "#25D366",
  borderRadius: "50%",
  width: "60px",
  height: "60px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  zIndex: 1000,
  boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
};

const imageStyle = {
  width: "35px",
  height: "35px",
};

export default WhatsAppButton;
